<template>
  <div>
    <section class="section">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <div class="logo">
              <figure class="image is-128x128">
                  <svg data-name="LOGO GRADIENT 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 640 580"><defs><linearGradient id="a" x1="11.52" y1="118.79" x2="331.14" y2="118.79" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2d5fa6"/><stop offset="1" stop-color="#9ad6f1"/></linearGradient><linearGradient id="b" x1="259.73" y1="521.87" x2="480.54" y2="249.19" xlink:href="#a"/></defs><path d="M233.42 325v88.25c16.37-3.54 28.86-21.93 28.86-44.13s-12.49-40.57-28.86-44.12z" fill-rule="evenodd" fill="#2d5fa6"/><path d="M331.14 197C170.84 131.25 11.52 6.83 11.52 6.83s129.83 158.62 255.3 223.91z" fill="url(#a)" fill-rule="evenodd"/><path d="M640 378.9S366.22 140.21 261.44 204.73c-132.5 81.6-2.74 295.55 68.8 374.24 0 0-167.1-230-55.67-314.47C362.34 198 640 378.9 640 378.9z" fill="url(#b)" fill-rule="evenodd"/></svg>
              </figure>
              <h1 class="title has-text-centered">HCG</h1>
              <br>
            </div>
            
            <div class="box">
              <h3 class="title">Login</h3>
              <p class="subtitle">Please login to proceed.</p>
              <form>
                <div class="field">
                  <div class="control">
                    <input v-model="email" class="input" type="email" placeholder="Your Email" autofocus="">
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input v-model="password" class="input" type="password" placeholder="Your Password">
                  </div>
                </div>
                <div class="field">
                  <label class="checkbox">
                    <input type="checkbox">
                    Remember me
                  </label>
                </div>
                <button @click="login" class="button is-block is-info is-large is-fullwidth">Login</button>
              </form>
            </div>
            <!--
            <p class="has-text-grey">
              <router-link to="/signup">Sign Up</router-link> &nbsp;·&nbsp;
              <a href="../">Forgot Password</a> &nbsp;·&nbsp;
              <a href="../">Need Help?</a>
            </p>-->
          </div>
        </div>

  </section>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'Login',

  data () {
    return {
      email: '',
      password: ''
    }
  },

  methods: {
    login () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.$router.replace('home/dashboard')
        },
        function (err) {
          alert(err)
        }
      )
    }
  }
}
</script>

<style scoped>
.image {
  margin: auto;
}

</style>


// WEBPACK FOOTER //
// src/views/Login.vue